import {React} from 'react';
import {BrowserRouter as Router,Switch,Route,Link} from 'react-router-dom';
import ApiComponent from './components/ApiComponent';
import BanksComponent from './components/BanksComponent';
import ExamplesComponent from './components/ExamplesComponent';
import ErrorsCodeComponent from './components/ErrorsCodeComponent';
import FaqComponent from './components/FaqComponent';
import InicioComponent from './components/InicioComponent';
import OverviewComponent from './components/OverviewComponent';
import FieldsComponent from './components/FieldsComponent';
import DocumentTypeCountryComponent from './components/DocumentTypeCountryComponent';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Navbar,Nav,NavDropdown,Button,Form,FormControl,Container } from 'react-bootstrap';
import '../src/App.css';
import { Component } from 'react';
import DownloadFile from './components/DownloadFileComponent';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = { color: "#282c34" };
  }

  changeColor = color => {
    this.setState({ color });
  };


render(){  
  return <>
  <div style={{ background: this.state.color }} >
    <Container fluid={true}>
      <Navbar bg="dark" variant="dark">
        <Navbar.Brand href="/">Remitte Info API Inbound</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mr-auto">
            <Nav.Link href="/api" onClick={() => this.changeColor("#007bff")}>Api Definition </Nav.Link>
            <NavDropdown title="Documentation" id="basic-nav-dropdown">
                 <NavDropdown.Item href="/overview"> Resume Documentation API</NavDropdown.Item>
                 <NavDropdown.Item href="Fields">Mandatory/Optional Fields</NavDropdown.Item>
                 <NavDropdown.Item href="Document">Documents by Country</NavDropdown.Item>

                              {/*<NavDropdown.Divider /> */}
                 <NavDropdown.Item href="banks">Banks</NavDropdown.Item>
                 <NavDropdown.Item href="TestCase">Integration Test Cases</NavDropdown.Item>
                 <NavDropdown.Item href="ErrorsCode">Errors Code</NavDropdown.Item>

            </NavDropdown>
            <Nav.Link href="/examples">Download Examples RPOs</Nav.Link>
            <Nav.Link href="/faq">FAQS</Nav.Link>
           
          </Nav>
          {/* <Form inline>
            <FormControl type="text" placeholder="Search" className="mr-sm-2" />
            <Button variant="outline-success">Search</Button>
          </Form> */}
        </Navbar.Collapse>
      </Navbar>
      
      <Router>
      
        <Switch>
          <Route path="/examples" exact>
            <DownloadFile/>
          </Route>
          <Route path="/faq" exact>
            <FaqComponent />
          </Route>
          <Route path="/api" exact>
            <ApiComponent />
          </Route>
          <Route path="/Fields" exact>
            <FieldsComponent />
          </Route>
          <Route path="/Document" exact>
            <DocumentTypeCountryComponent />
          </Route>
          <Route path="/banks" exact>
            <BanksComponent />
          </Route>
          <Route path="/overview" exact>
            <OverviewComponent />
          </Route>
          <Route path="/faq" exact>
            <FaqComponent/>
          </Route>
          <Route path="/ErrorsCode" exact>
              <ErrorsCodeComponent />
           </Route>
           <Route path="/TestCase" exact>
              <ExamplesComponent />
           </Route>
          <Route path="/" exact>
            <ApiComponent />
          </Route>
        </Switch>
      
      </Router>
      
      </Container>
      </div>
  </>
 
}
}

export default App;